import React from 'react';
import Text from 'fe-design-base/atoms/Text';
import Dialog from 'fe-design-base/organisms/Dialog';
import PropTypes from 'prop-types';

import { toI18n } from 'util/i18n';

const DeleteTimecardModal = ({ open, handleConfirmDelete, handleClose }) => (
  <Dialog
    title={
      <Text
        i18n="timecard_modal_v3.header.delete.dialog.title"
        color="mono900"
        variant="heading2"
      />
    }
    buttons={[
      {
        label: toI18n('timecard_modal_v3.header.delete.dialog.confirm'),
        variant: 'primaryDestructive',
        onClick: handleConfirmDelete,
      },
      {
        label: toI18n('timecard_modal_v3.header.delete.dialog.cancel'),
        variant: 'tertiary',
        onClick: handleClose,
      },
    ]}
    open={open}
    onClose={handleClose}
    width={583}
  >
    {() => (
      <Text
        i18n="timecard_modal_v3.header.delete.dialog.description"
        variant="body"
        color="mono900"
      />
    )}
  </Dialog>
);

DeleteTimecardModal.propTypes = {
  open: PropTypes.bool,
  handleConfirmDelete: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DeleteTimecardModal;
